import axios from '../../axios'

/*
 * 登录数据接口
 */

// 登录
export const login = (data) => {
    return axios({
        url: '/api/admin/login',
        method: 'post',
        data,
        application: 'user'
    })
}

// 退出
export const logout = (data) => {
    return axios({
        url: '/logout',
        method: 'post',
        data,
        application: 'admin'
    })
}

// 获取验证码
export const getCode = (data) => {
    return axios({
        url: '/api/sms/user/code',
        method: 'get',
        data,
        application: 'user'
    })
}

// 注册
export const register = (data) => {
    return axios({
        url: '/api/admin/partners/register',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/sys/login.js